import React from "react";
import {UiButton} from "../ui-components/button/uiButton";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router";

type CantPlayGameType = {
    reason?: string
    score?: number
    date?: string
    rank?: number
}

export const CantPlayGame: React.FC<CantPlayGameType> = (props) => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <>
            {props.date === undefined ? (
                <div className="flex flex-col items-center justify-center">
                    <h2 className="text-2xl font-bold text-center mb-8">
                        {t("game.create-account-to-play-this-gamemode")}
                    </h2>

                    <UiButton
                        icon="user"
                        className="w-fit"
                        text={t("global.connection-page")}
                        onClick={() => window.location.href = "/login"}
                    />
                </div>
            ) : (
                <div className="flex flex-col items-center gap-16">
                    {props.reason && (
                        <h2 className="text-2xl font-bold text-center">{props.reason}</h2>
                    )}

                    <div className="flex justify-center flex-wrap gap-12">
                        {props.score !== undefined && (
                            <div className="flex flex-col md:flex-row w-full md:w-fit items-center gap-2">
                                <img className="bg-purple-blue h-11 p-2.5 rounded-xl" src="/icons/input.svg" alt="" />
                                <span>{t("stats.your-score-x", {score: props.score})}</span>
                            </div>
                        )}

                        {props.rank !== undefined && (
                            <div className="flex flex-col md:flex-row w-full md:w-fit items-center gap-2">
                                <img className="bg-purple-blue h-11 p-2.5 rounded-xl" src="/icons/trophy.svg" alt="" />
                                <span>{t("stats.x-rank", {count: props.rank})}</span>
                            </div>
                        )}

                        {props.date && (
                            <div className="flex flex-col md:flex-row w-full md:w-fit items-center gap-2">
                                <img className="bg-purple-blue h-11 p-2.5 rounded-xl" src="/icons/stop-watch.svg" alt="" />
                                <span>{t("global.date-x-datetime_format_xxhmm-dd/mm", {date: props.date})}</span>
                            </div>
                        )}
                    </div>

                    <UiButton
                        className="w-fit"
                        icon="ranking"
                        text={t("global.leaderboard")}
                        onClick={() => navigate("/leaderboard")} />
                </div>
            )}
        </>
    )
}
